import React from "react";
import "./StatusPill.css";

function StatusPill({ tone = "idle", pulse = false, children, className = "" }) {
    return (
        <span
            className={`status-pill status-pill--${tone} ${pulse ? "status-pill--pulse" : ""} ${className}`}
            role="status"
        >
            <span className="status-pill__dot" aria-hidden="true" />
            <span className="status-pill__label">{children}</span>
        </span>
    );
}

export default StatusPill;
